"use client";

import { AspectRatio as AspectRatioPrimitive } from "radix-ui";

/**
 * Locks a child to a fixed width-to-height ratio.
 *
 * Pass `ratio={16 / 9}` for video tiles, `4 / 3` for portrait media.
 * The child receives 100% width and height; use `object-cover` on
 * `<img>` children to fill correctly.
 */
function AspectRatio({ ...props }: React.ComponentProps<typeof AspectRatioPrimitive.Root>) {
  return <AspectRatioPrimitive.Root data-slot="aspect-ratio" {...props} />;
}

export { AspectRatio };
